/**
 * Per-locale FAQ copy. The whole page (3 category headers, 11 question
 * and answer pairs) and its FAQPage JSON-LD rendered Dutch on
 * de/en/fr/es/it until 2026-08-03.
 *
 * Each locale exports a builder rather than a static table because four
 * of the answers state live shipping and returns terms. Those numbers
 * must be interpolated from the policy the backend returns, never
 * written into the copy: a literal threshold in a translation string is
 * exactly how German pages came to promise free shipping at 50 while
 * the customer was charged up to 75 (see
 * scripts/test-shipping-copy-truth.mjs).
 *
 * The policy is still fetched for NL and BE only, so every locale's
 * shipping answers name the country the terms apply to. Making the
 * policy itself locale-aware is a money-surface change and is tracked
 * separately; translating the copy must not quietly turn a Dutch fact
 * into a promise to a German reader.
 */

import type { FAQPolicyValues, FAQSection } from "../faq-data.ts";
import de from "./de.ts";
import en from "./en.ts";
import fr from "./fr.ts";
import es from "./es.ts";
import it from "./it.ts";

/** Formatting helpers passed in by buildFaqs so the locale files do not
 *  import back into faq-data at runtime. `deliveryWindow` is already
 *  localized; `eur` renders the Dutch-style decimal comma. */
export interface FaqFormatters {
  eur: (n: number) => string;
  deliveryWindow: string;
}

export type FaqBuilder = (p: FAQPolicyValues, fmt: FaqFormatters) => FAQSection[];

export const FAQ_TRANSLATIONS: Record<string, FaqBuilder> = { de, en, fr, es, it };
